import {
  createContext, useEffect, useState,
} from 'react';
import { toast } from 'react-toastify';
import {
  Label, CustomInput, IconWrapper, ModalTitle3, LabelSwitch,
} from './styles';
import {
  Button, Input,
} from 'components';
import { useStateVar } from 'helpers/useStateVar';
import { apiCall } from 'providers';
import { Flex } from 'reflexbox';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { UtilityIcon } from '~/icons/Utility';
import {
  DatIcon, MonitoringIcon, PortIcon,
} from '~/icons';
import { ToggleSwitchMini } from '~/components/ToggleSwitch';
import { InputWithValidation } from '~/components/InputWithValidation';
import { SelectDMTport } from '~/components/SelectDmtPort';
import { t } from 'i18next';
import { typesUtilities, utilityNamesMap, utilityNamesMapReverse } from '../Analysis/DMTs/AcessorUtilities';
import { AccordionV2 } from '~/components/Accordion';
import { colors } from '~/styles/colors';

export const InputValidationContext = createContext({});

export const addUnitToString = (str: string|null, unit: string) : string => (str ? `${str} ${unit}` : '');
export const propOrNullValue = (value) => (value || null);
export const getParamNumber = (param: string|null) => (param?.split(' ').length ? Number(param.split(' ')[0]) : null);

export const FormEditUtility = ({
  clientId, onSuccess, onCancel, utilityInfo, utilityType, models, modelDescs,
}): JSX.Element => {
  const [state, render, setState] = useStateVar({
    submitting: false,
    editingExtras: false,
    brandList: [] as string[],
    hasMonitoring: !!utilityInfo?.DEVICE_CODE,
    selectPortNow: !!utilityInfo?.PORT || (!!utilityInfo?.DEVICE_CODE && !!utilityInfo?.FEEDBACK),
    hasDatId: !!utilityInfo?.DAT_CODE,
    buttonDisabled: !utilityInfo?.DEVICE_CODE,
    unitsOpt: [] as {value: number, name: string}[],
    portsOpt: [] as {label: string, associated: boolean, port: number, nobreakId?: number, illuminationId?: number}[],
    feedbackOpt: [] as {label: string, associated: boolean, port: number, illuminationId?: number}[],
    applicationOpts: [] as {name: string, value: string}[],
    optionsModels: [] as {name: string, value: string}[],
    newDevice: false as boolean,
    hasMachine: false as boolean,
    openModelOpts: false as boolean,
  });

  function getPort() {
    if (!utilityInfo?.PORT) return '';
    if (['Elevator', 'Escalator'].includes(utilityInfo?.APPLICATION)) return { label: `P${utilityInfo?.PORT - 1}`, port: utilityInfo?.PORT };
    return { label: `F${utilityInfo?.PORT}`, port: utilityInfo?.PORT };
  }

  const propOrEmpty = (prop) => (prop || '');
  function getFormDataInitialState() {
    return {
      ID: (utilityInfo?.ID) || null,
      NAME: propOrEmpty(utilityInfo?.NAME),
      UNIT: propOrEmpty(utilityInfo?.UNIT_ID),
      APPLICATION: propOrEmpty(utilityInfo.APPLICATION),
      INSTALLATION_DATA: (utilityInfo?.INSTALLATION_DATE) ? utilityInfo.INSTALLATION_DATE.substring(0, 10) : '' as any,
      MANUFACTURER: propOrEmpty(utilityInfo?.MANUFACTURER),
      MODEL: propOrEmpty(utilityInfo?.UTILITY_MODEL_ID),
      MONITORING_DEVICE: propOrEmpty(utilityInfo?.DEVICE_CODE),
      DAT_ID: propOrEmpty(utilityInfo?.DAT_CODE),
      PORT: getPort(),
      FEEDBACK: (utilityInfo?.FEEDBACK) ? { label: 'F'.concat(String(utilityInfo.FEEDBACK)), port: utilityInfo.FEEDBACK } : '' as any,
      GRID_VOLTAGE: addUnitToString(utilityInfo?.GRID_VOLTAGE, 'VAC') as any,
      GRID_CURRENT: propOrEmpty(utilityInfo?.GRID_CURRENT),
      PORT2: utilityInfo?.PORT2 ? { label: `F${utilityInfo?.PORT2}`, port: utilityInfo?.PORT2 } : '' as any,
      DEVICE_CODE: propOrEmpty(utilityInfo?.DEVICE_CODE),
      SENSOR: propOrEmpty(utilityInfo?.SENSOR),
      DEFAULT_MODE: propOrEmpty(utilityInfo?.DEFAULT_MODE),
    };
  }

  const fetchData = async () => {
    try {
      const data = await apiCall('/clients/get-units-list', { CLIENT_ID: clientId });
      const opts: {value: number, name: string}[] = [];
      for (const unit of data) {
        opts.push({ value: unit.UNIT_ID, name: unit.UNIT_NAME });
      }
      setState({ unitsOpt: opts });
    } catch (err) {
      console.log(err);
      toast.error('Houve erro');
    }
  };
  const normalizeKey = (value: string) => value.toLowerCase().replace(/\s+/g, '').replace(/_/g, '').trim();

  useEffect(() => {
    const appKey = normalizeKey(formData.APPLICATION);
    const applicationOptsLocal = Object.entries(utilityNamesMap).map(([key, value]) => ({ name: value, value: key }));
    const optionsModels = models[typesUtilities[appKey]] || [];
    setState({ applicationOpts: applicationOptsLocal, optionsModels });
    fetchData();
  }, []);

  const [allowedMonitoring, setAllowedMonitoring] = useState(!!utilityInfo?.DMT_CODE || !!utilityInfo?.DAL_CODE || !!utilityInfo?.DAM_ILLUMINATION_CODE);
  const [formData, setFormData] = useState(getFormDataInitialState());
  const isEdit = !!formData.ID;

  useEffect(() => {
    const appKey = normalizeKey(formData.APPLICATION);
    const optionsModels = models[typesUtilities[appKey]] || [];
    setState({ optionsModels });
  }, [formData.APPLICATION]);

  function checkErrorNobreakFormData() {
    if (!formData.NAME) { toast.error(t('necessarioNomeUtilitario')); state.submitting = false; return true; }
    if (!formData.APPLICATION) { toast.error(t('necessarioCampoAplicacao')); state.submitting = false; return true; }
    if (!formData.UNIT) { toast.error(t('necessarioCampoUnidade')); state.submitting = false; return true; }
    if (state.hasMonitoring && !formData.MONITORING_DEVICE && !allowedMonitoring) { toast.error(t('necessarioDispositivoDeMonitoramento')); state.submitting = false; return true; }
    if (state.hasMonitoring && allowedMonitoring && state.selectPortNow && !formData.PORT && !formData.PORT.port) { toast.error(t('necessarioCampoPortaDmt')); state.submitting = false; return true; }
    return false;
  }

  function checkErrorIllumFormData() {
    if (!formData.NAME) { toast.error(t('necessarioNomeUtilitario')); state.submitting = false; return true; }
    if (!formData.APPLICATION) { toast.error(t('necessarioCampoAplicacao')); state.submitting = false; return true; }
    if (!formData.UNIT) { toast.error(t('necessarioCampoUnidade')); state.submitting = false; return true; }
    if (state.hasMonitoring && !formData.MONITORING_DEVICE && !allowedMonitoring) { toast.error(t('necessarioDispositivoDeAutomacao')); state.submitting = false; return true; }
    if (state.hasMonitoring && allowedMonitoring && state.selectPortNow && !formData.PORT && !formData.PORT.port) { toast.error(t('necessarioCampoPortaDal')); state.submitting = false; return true; }
    return false;
  }

  const propOrNull = (prop) => (prop || null);

  function validateFormDataByApplication() {
    if (!formData.UNIT) {
      toast.info(t('selecioneUnidade'));
      return true;
    }
    if (!formData.APPLICATION) {
      toast.info(t('selecioneAplicacao'));
      return true;
    }
    if (formData.APPLICATION === t('nobreak')) {
      return checkErrorNobreakFormData();
    }
    if (formData.APPLICATION === t('iluminacao')) {
      return checkErrorIllumFormData();
    }
    return false;
  }

  async function confirm() {
    let response;
    let action: string|null = null;
    try {
      state.submitting = true; render();
      if (validateFormDataByApplication()) {
        state.submitting = false; render(); return;
      }
      if (formData.APPLICATION) {
        const gridVoltageSplitted = formData.GRID_VOLTAGE?.trim().split(' ');
        const port = state.selectPortNow && formData.PORT && formData.PORT.port;
        const port2 = state.selectPortNow && formData.PORT2 && formData.PORT2.port;
        const result = await apiCall('/dmt/set-utilities', {
          DEVICE_CODE: state.hasMonitoring ? formData.MONITORING_DEVICE : null,
          ID: formData.ID,
          NAME: formData.NAME,
          MANUFACTURER: formData.MANUFACTURER,
          SENSOR: propOrNull(formData.SENSOR),
          INSERT: !isEdit,
          APPLICATION: formData.APPLICATION,
          UTILITY_ID: formData.ID,
          PORT: port ? Number(port) : undefined,
          PORT2: port2 ? Number(port2) : undefined,
          GRID_VOLTAGE: gridVoltageSplitted.length ? Number(gridVoltageSplitted[0]) : undefined,
          GRID_CURRENT: propOrNull(formData.GRID_CURRENT),
          FEEDBACK: port ? Number(port) : undefined,
          UNIT_ID: propOrNull(formData.UNIT),
          INSTALLATION_DATE: propOrNull(formData.INSTALLATION_DATA),
          MODEL_ID: propOrNull(formData.MODEL),
          MODEL: propOrNull(modelDescs[formData.MODEL]?.MODEL_NAME),
          DEFAULT_MODE: propOrNull(formData.DEFAULT_MODE),
        });
        response = result;
        action = isEdit ? 'edit' : 'new';
      }
    } catch (err) {
      console.log(err);
      toast.error(t('houveErro'));
    }
    state.submitting = false; render();
    if (response && action) onSuccess({ item: response, action });
  }

  function checkMonitoring() {
    if (utilityInfo && utilityInfo.DMT_CODE === formData.MONITORING_DEVICE) {
      setAllowedMonitoring(true);
      state.buttonDisabled = false;
    } else if ((!state.hasMonitoring) || (state.hasMonitoring && allowedMonitoring && !state.selectPortNow) || (state.hasMonitoring && allowedMonitoring && state.selectPortNow && formData.PORT)) {
      state.buttonDisabled = false;
    } else {
      state.buttonDisabled = true;
    }
  }

  const getDmtPortsOpts = async () => {
    const ports = await apiCall('/dmt/get-dmt-ports-info', { DMT_CODE: formData.MONITORING_DEVICE, CLIENT_ID: clientId, NEW_UTILITY_TYPE: utilityType === t('nobreak') ? 'Nobreak' : 'Illumination' });
    return {
      ports: ports.portsAnalogics.map((port) => { if (utilityInfo && port.utilityId === utilityInfo.ID) { port.associated = false; } return port; }),
      feedbacks: ports.portsDigitals.map((fb) => { if (utilityInfo && fb.utilityId === utilityInfo.ID) { fb.associated = false; } return fb; }),
    };
  };

  const getDalPortsOpts = async () => {
    const ports = await apiCall('/dal/get-dal-ports-info', { DAL_CODE: formData.MONITORING_DEVICE, CLIENT_ID: clientId });
    return {
      ports: ports.ports.map((port) => { if (utilityInfo && port.illuminationId === utilityInfo.ID) { port.associated = false; } return port; }),
      feedbacks: ports.feedbacks.map((fb) => { if (utilityInfo && fb.illuminationId === utilityInfo.ID) { fb.associated = false; } return { ...fb, label: 'F'.concat(fb.label) }; }),
    };
  };

  async function getPortsOpts() {
    if (formData.APPLICATION === 'Illumination' && formData.MONITORING_DEVICE.startsWith('DAL')) {
      const ports = await getDalPortsOpts();
      return ports;
    }
    const ports = await getDmtPortsOpts();
    return ports;
  }

  useEffect(() => {
    (async function () {
      if (formData.MONITORING_DEVICE && state.selectPortNow) {
        const portsInfo = await getPortsOpts();
        state.portsOpt = portsInfo.ports;
        state.feedbackOpt = portsInfo.feedbacks;
      }
      if (!allowedMonitoring) {
        checkMonitoring();
      } else if (state.hasMonitoring && state.selectPortNow) {
        if (formData.MONITORING_DEVICE) {
          const portsInfo = await getPortsOpts();
          state.portsOpt = portsInfo.ports;
          state.feedbackOpt = portsInfo.feedbacks;
        }
        state.buttonDisabled = !(formData.MONITORING_DEVICE && formData.PORT);
      } else {
        state.buttonDisabled = false;
      }
      render();
    }());
  }, [allowedMonitoring, formData.MONITORING_DEVICE, formData.PORT, state.hasMonitoring, state.selectPortNow]);

  const validateMonitoringDmtUtility = async () : Promise<boolean|null> => {
    if (!['Nobreak', 'Illumination'].includes(formData.APPLICATION) && !formData.MONITORING_DEVICE.startsWith('DMT2')) {
      state.buttonDisabled = true;
      toast.error('Dispositivo de monitoramento inválido');
      return null;
    }
    try {
      const ans = await apiCall('/dmt/get-dmt-ports-info', { DMT_CODE: formData.MONITORING_DEVICE, CLIENT_ID: clientId, NEW_UTILITY_TYPE: formData.APPLICATION === t('nobreak') ? 'Nobreak' : 'Illumination' });
      if (utilityInfo && utilityInfo.DMT_CODE === formData.MONITORING_DEVICE && utilityInfo.ID) {
        return true;
      }
      return ans.freePorts;
    } catch (err) {
      return null;
    }
  };

  const validateMonitoringIllumination = async () : Promise<boolean|null> => {
    try {
      const ans = await apiCall('/dal/get-dal-ports-info', { DAL_CODE: formData.MONITORING_DEVICE, CLIENT_ID: clientId });
      if (utilityInfo && utilityInfo.DAL_CODE === formData.MONITORING_DEVICE && utilityInfo.ID) {
        return true;
      }
      return ans.freePorts;
    } catch (err) {
      return null;
    }
  };

  const validateMonitoringDamIlluminationUtility = async () : Promise<boolean|null> => {
    try {
      const ans = await apiCall('/dam/get-dam-illumination-validation', { DAM_ILLUMINATION_CODE: formData.MONITORING_DEVICE, CLIENT_ID: clientId, UNIT_ID: formData.UNIT });
      if (utilityInfo && utilityInfo.DAM_ILLUMINATION_CODE === formData.MONITORING_DEVICE && utilityInfo.ID) {
        return true;
      }
      state.newDevice = ans.newDevice;
      state.hasMachine = ans.hasMachine;
      render();
      return ans.freeDevice;
    } catch (err) {
      return null;
    }
  };

  const notValidate = async () : Promise<boolean|null> => null;

  const handleValidateFunction = async () : Promise<boolean|null> => {
    if (formData.MONITORING_DEVICE.startsWith('DAM')) {
      return validateMonitoringDamIlluminationUtility();
    }
    if (formData.MONITORING_DEVICE.startsWith('DMT')) {
      return validateMonitoringDmtUtility();
    }
    if (formData.MONITORING_DEVICE.startsWith('DAL')) {
      return validateMonitoringIllumination();
    }
    return notValidate();
  };

  const getDeviceFormLabels = (application) => {
    if (application !== 'Illumination') {
      return {
        deviceCode: 'DMT_CODE',
        deviceIdText: t('digiteIdDmt'),
        devicePortText: t('portaDoDmt'),
        feedbackText: t('feedbackDoDmt'),
        monitoringText: t('dispositivoDeMonitoramento'),
        validateFunction: validateMonitoringDmtUtility,
      };
    }
    return {
      deviceCode: 'DAL_CODE',
      deviceIdText: t('digiteIdDalDmtDam'),
      devicePortText: t('portaDoDal'),
      feedbackText: t('feedbackDoDal'),
      monitoringText: t('dispositivoDeAutomacao'),
      validateFunction: handleValidateFunction,
    };
  };

  const monitoringDeviceForm = () => {
    const labels = getDeviceFormLabels(formData.APPLICATION);

    if (labels.deviceCode) {
      return (
        <>
          <Flex flexDirection="row" justifyContent="space-between">
            <Flex flexDirection="column">
              <Flex flexDirection="row" alignItems="center">
                <IconWrapper>
                  <MonitoringIcon />
                </IconWrapper>
                <ModalTitle3>{t('possuiMonitoramento')}</ModalTitle3>
              </Flex>
              <div style={{ marginLeft: '34px' }}>
                <LabelSwitch>{t('nao')}</LabelSwitch>
                <ToggleSwitchMini
                  checked={state.hasMonitoring}
                  onClick={() => { state.hasMonitoring = !state.hasMonitoring; render(); formData.PORT = (state.hasMonitoring && utilityInfo && utilityInfo[labels.deviceCode] === formData.MONITORING_DEVICE && utilityInfo.PORT) || ''; render(); }}
                  style={{ marginLeft: '8px', marginRight: '8px' }}
                  dataTestId="toggle-switch-monitoring"
                />
                <LabelSwitch>{t('sim')}</LabelSwitch>
              </div>
            </Flex>
            <div style={{ width: '48%' }}>
              <InputValidationContext.Provider value={{ allowedMonitoring, setAllowedMonitoring }}>
                <InputWithValidation
                  type="text"
                  value={formData.MONITORING_DEVICE}
                  label={labels.monitoringText}
                  placeholder={labels.deviceIdText}
                  onChange={(event) => {
                    setFormData((prev) => ({
                      ...prev,
                      MONITORING_DEVICE: event.target.value,
                      PORT: '',
                      FEEDBACK: '',
                    }));
                    setAllowedMonitoring(false);
                  }}
                  disabled={!state.hasMonitoring}
                  validateFunction={labels.validateFunction}
                  newDevice={state.newDevice}
                  hasMachine={state.hasMachine}
                />
              </InputValidationContext.Provider>
            </div>
          </Flex>
          <div style={{ paddingTop: '5px' }} />

          <Flex flexDirection="row" style={{ position: 'relative' }} alignItems="center" justifyContent="space-between">
            <Flex flexDirection="column" width="48%">
              <Flex flexDirection="row" alignItems="center">
                <IconWrapper>
                  <PortIcon />
                </IconWrapper>
                <ModalTitle3>{t('portaUtilizada')}</ModalTitle3>
              </Flex>
              <Flex style={{ marginLeft: '34px' }}>
                <LabelSwitch>{t('selecionarDepois')}</LabelSwitch>
                <ToggleSwitchMini
                  checked={state.selectPortNow}
                  onClick={() => {
                    state.selectPortNow = !state.selectPortNow;
                    formData.PORT = (state.selectPortNow && utilityInfo && utilityInfo[labels.deviceCode] === formData.MONITORING_DEVICE && utilityInfo.PORT) || '';
                    formData.FEEDBACK = (state.selectPortNow && utilityInfo && utilityInfo[labels.deviceCode] === formData.MONITORING_DEVICE && utilityInfo.FEEDBACK) || '';
                    render();
                  }}
                  style={{ marginLeft: '8px', marginRight: '8px' }}
                  dataTestId="toggle-switch-port"
                />
                <LabelSwitch>{t('selecionarAgora')}</LabelSwitch>
              </Flex>
            </Flex>
            <Flex flexWrap="wrap" style={{ gap: '10px', width: state.selectPortNow ? '48%' : '48%', justifyContent: 'flex-end' }}>
              {
                ['Elevator', 'Escalator'].includes(formData.APPLICATION) ? (
                  <div style={{ width: '100%' }}>
                    <SelectDMTport
                      label={labels.devicePortText}
                      placeholder={t('selecionar')}
                      options={state.portsOpt}
                      propLabel="label"
                      value={formData.PORT}
                      hideSelected
                      onSelect={(item) => {
                        formData.PORT = item;
                        render();
                      }}
                      disabled={!state.selectPortNow}
                    />
                  </div>
                ) : (
                  <div style={{ width: '100%' }}>
                    <SelectDMTport
                      label={labels.feedbackText}
                      placeholder={t('selecionar')}
                      options={state.feedbackOpt}
                      propLabel="label"
                      value={formData.PORT}
                      hideSelected
                      onSelect={(item) => {
                        formData.PORT = item;
                        render();
                      }}
                      disabled={!state.selectPortNow}
                    />
                  </div>
                )
              }
              {formData.APPLICATION === 'Generator' && (
                <div style={{ width: '100%' }}>
                  <SelectDMTport
                    label={t('feedbackGerador')}
                    placeholder={t('selecionar')}
                    options={state.feedbackOpt}
                    propLabel="label"
                    value={formData.PORT2}
                    hideSelected
                    onSelect={(item) => {
                      formData.PORT2 = item;
                      render();
                    }}
                    disabled={!state.selectPortNow}
                  />
                </div>
              )}
            </Flex>
            {(!allowedMonitoring || !state.hasMonitoring || formData.MONITORING_DEVICE.startsWith('DAM')) && (
            <div style={{
              zIndex: 1, background: '#ffffff', width: '100%', height: '100%', position: 'absolute', opacity: 0.7, top: 0, left: 0, borderRadius: '5px',
            }}
            />
            )}

          </Flex>
        </>
      );
    }
  };

  return (
    <div style={{ margin: '25px' }}>
      <Flex flexDirection="row" justifyContent="space-between">
        <Flex flexDirection="row" alignItems="center" mb="10px">
          <IconWrapper>
            <UtilityIcon />
          </IconWrapper>
          <ModalTitle3>{t('novoUtilitario')}</ModalTitle3>
        </Flex>
        {formData.ID && (
        <Flex flexDirection="row" alignItems="center" mb="10px">
          <ModalTitle3>ID:&nbsp;</ModalTitle3>
          <span>{formData.ID}</span>
        </Flex>
        )}
      </Flex>
      <Input
        type="text"
        value={formData.NAME}
        label={t('nomeDoUtilitario')}
        placeholder={t('digiteNomeUtilitario')}
        onChange={(event) => { formData.NAME = event.target.value; render(); }}
      />
      <div style={{ paddingTop: '10px' }} />
      <CustomInput style={{ width: '100%' }}>
        <div style={{ width: '100%', paddingTop: 3, zIndex: 11 }}>
          <Label>{t('unidade')}</Label>
          <SelectSearch
            options={state.unitsOpt}
            value={formData.UNIT}
            onChange={(item) => { formData.UNIT = item; render(); }}
            search
            filterOptions={fuzzySearch}
            placeholder={t('selecioneUnidade')}
            closeOnSelect={false}
          />
        </div>
      </CustomInput>
      <div style={{ paddingTop: '10px' }} />
      <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
        <div style={{ width: formData.APPLICATION === t('iluminacao') ? '100%' : '48%' }}>
          <CustomInput style={{ width: '100%' }}>
            <div style={{ width: '100%', paddingTop: 3 }}>
              <Label>{t('aplicacao')}</Label>
              <SelectSearch
                options={state.applicationOpts}
                value={formData.APPLICATION}
                onChange={(item) => { formData.APPLICATION = item; render(); }}
                placeholder="Selecione a aplicação"
                closeOnSelect={false}
              />
            </div>
          </CustomInput>
        </div>
        {' '}
        {formData.APPLICATION === t('nobreak') && (
          <div style={{ width: '48%' }}>
            <Input
              width="100%"
              type="date"
              value={formData.INSTALLATION_DATA}
              label={t('dataInstalacao')}
              onChange={(event) => { formData.INSTALLATION_DATA = event.target.value; render(); }}
            />
          </div>
        )}
      </Flex>
      {formData.APPLICATION !== 'Illumination' && (
        <>
          <div style={{ paddingTop: '10px' }} />

          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
            <div style={{ width: '48%' }}>
              <Input
                type="text"
                value={formData.MANUFACTURER}
                label={t('fabricante')}
                placeholder={t('digiteFabricante')}
                onChange={(event) => { formData.MANUFACTURER = event.target.value; render(); }}
              />
            </div>
            {' '}
            <div style={{ width: '48%' }}>
              <CustomInput style={{ width: '100%' }}>
                <div style={{ width: '100%', paddingTop: 3 }}>
                  <Label>{t('modelo')}</Label>
                  <SelectSearch
                    options={state.optionsModels}
                    value={formData.MODEL}
                    onChange={(item) => { formData.MODEL = item; render(); }}
                    placeholder={t('selecioneModelo')}
                    closeOnSelect
                  />
                </div>
              </CustomInput>
            </div>
          </Flex>
          <div style={{ paddingTop: '10px' }} />
          <AccordionV2 color={colors.Blue300} style={{ fontSize: '0.9rem', marginBottom: '5px', marginTop: '5px' }} title={t('informacoesDoModelo')} opened={false}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
              {
                formData.MODEL && modelDescs?.[formData.MODEL]?.INFO.map((model) => (
                  <>
                    <div style={{ width: '100%' }}>
                      <Input
                        type="number"
                        value={model.VALUE}
                        disabled
                        label={model.FIELD_NAME}
                        onChange={() => {}}
                        suffix={model.MEASURE_UNIT}
                        noSuffixBorder
                      />
                    </div>
                    {' '}
                  </>
                ))
              }
            </div>
          </AccordionV2>
          <div style={{ paddingTop: '10px' }} />
          {monitoringDeviceForm()}

          <div style={{ paddingTop: '15px' }} />

          <Flex flexDirection="row" justifyContent="space-between">
            <Flex flexDirection="column">
              <Flex flexDirection="row" alignItems="center">
                <IconWrapper>
                  <DatIcon />
                </IconWrapper>
                <ModalTitle3>{t('possuiDatId')}</ModalTitle3>
              </Flex>
              <div style={{ marginLeft: '34px' }}>
                <LabelSwitch>{t('nao')}</LabelSwitch>
                <ToggleSwitchMini
                  checked={state.hasDatId}
                  onClick={() => { state.hasDatId = !state.hasDatId; render(); formData.DAT_ID = (state.hasDatId && utilityInfo && utilityInfo.DAT_ID) || ''; render(); }}
                  style={{ marginLeft: '8px', marginRight: '8px' }}
                />
                <LabelSwitch>{t('sim')}</LabelSwitch>
              </div>
            </Flex>
            <div style={{ width: '48%' }}>
              <Input
                type="text"
                value={formData.DAT_ID}
                label="DAT ID"
                placeholder={t('digiteId')}
                onChange={(event) => { formData.DAT_ID = event.target.value; render(); }}
                disabled={!state.hasDatId}
              />
            </div>
          </Flex>
        </>
      )}
      {formData.APPLICATION === 'Illumination' && (
        <>
          <div style={{ paddingTop: '10px' }} />

          <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
            <div style={{ width: '48%' }}>
              <CustomInput style={{ width: '100%' }}>
                <div style={{ width: '100%', paddingTop: 3, zIndex: 10 }}>
                  <Label>{t('tensaoDaRede')}</Label>
                  <SelectSearch
                    options={['127 VAC', '220 VAC', '380 VAC'].map((e) => ({ name: e, value: e }))}
                    value={formData.GRID_VOLTAGE}
                    onChange={(item) => { formData.GRID_VOLTAGE = item; render(); }}
                    placeholder={t('selecioneTensao')}
                    closeOnSelect={false}
                  />
                </div>
              </CustomInput>
            </div>
            {' '}
            <div style={{ width: '48%' }}>
              <Input
                type="text"
                value={formData.GRID_CURRENT}
                label={t('correnteDaRede')}
                placeholder={t('digitar')}
                onChange={(event) => {
                  const value = Number(event.target.value);
                  if (!Number.isNaN(value) && value >= 0) {
                    formData.GRID_CURRENT = event.target.value;
                    render();
                  }
                }}
                suffix="A"
              />
            </div>
          </Flex>

          <div style={{ paddingTop: '15px' }} />

          {monitoringDeviceForm()}

          <div style={{ paddingTop: '15px' }} />
        </>
      )}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingTop: '15px',
      }}
      >
        <Button disabled={state.hasMonitoring && !formData.MONITORING_DEVICE} style={{ width: '30%' }} onClick={confirm} variant="primary">
          {t('finalizar')}
        </Button>
      </div>
    </div>
  );
};
